var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 35,
    viewBox: "0 0 31 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.854813 1.00369C0.470701 1.41762 0.24884 2.05009 0.24884 2.87794V32.24C0.24884 33.0678 0.470701 33.7003 0.868055 34.0977L0.970654 34.187L17.4217 17.7362V17.3686L0.957538 0.914276L0.854813 1.00369Z",
    fill: "url(#paint0_linear_103_16)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8955 23.2363L17.4084 17.7494V17.3653L22.8955 11.8783L23.0146 11.9512L29.505 15.64C31.3626 16.6864 31.3626 18.415 29.505 19.4746L23.0146 23.1635L22.8955 23.2363Z",
    fill: "url(#paint1_linear_103_16)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0146 23.1635L17.4084 17.5573L0.854858 34.1108C1.46083 34.7599 2.47748 34.8328 3.6133 34.2003L23.0146 23.1635Z",
    fill: "url(#paint2_linear_103_16)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0146 11.9512L3.6133 0.93085C2.47748 0.281818 1.45748 0.371232 0.854858 1.02026L17.4084 17.5573L23.0146 11.9512Z",
    fill: "url(#paint3_linear_103_16)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8954 23.0442L3.62642 33.9917C2.55019 34.6109 1.58991 34.5678 0.97065 34.0049L0.867981 34.1076L0.97065 34.1969C1.58991 34.7566 2.55019 34.8029 3.62642 34.1837L23.0278 23.1635L22.8954 23.0442Z",
    fill: "#0e0333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5048 19.2825L22.8788 23.0442L22.9981 23.1635L29.4882 19.4746C30.4188 18.9448 30.8758 18.2493 30.8758 17.5573C30.8194 18.1931 30.346 18.7958 29.5048 19.2825Z",
    fill: "#0e0333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.61317 1.12281L29.5048 15.8319C30.346 16.3055 30.8195 16.9247 30.8924 17.5571C30.8924 16.8652 30.4354 16.1697 29.5048 15.6399L3.61317 0.930743C1.75554 -0.132206 0.24884 0.755249 0.24884 2.87784V3.0699C0.24884 0.943998 1.75554 0.0731053 3.61317 1.12281Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.854813 1.00369C0.470701 1.41762 0.24884 2.05009 0.24884 2.87794V32.24C0.24884 33.0678 0.470701 33.7003 0.868055 34.0977L0.970654 34.187L17.4217 17.7362V17.3686L0.957538 0.914276L0.854813 1.00369Z",
    fill: "url(#paint4_linear_103_16)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8955 23.2363L17.4084 17.7494V17.3653L22.8955 11.8783L23.0146 11.9512L29.505 15.64C31.3626 16.6864 31.3626 18.415 29.505 19.4746L23.0146 23.1635L22.8955 23.2363Z",
    fill: "url(#paint5_linear_103_16)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0146 23.1635L17.4084 17.5573L0.854858 34.1108C1.46083 34.7599 2.47748 34.8328 3.6133 34.2003L23.0146 23.1635Z",
    fill: "url(#paint6_linear_103_16)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0146 11.9512L3.6133 0.93085C2.47748 0.281818 1.45748 0.371232 0.854858 1.02026L17.4084 17.5573L23.0146 11.9512Z",
    fill: "url(#paint7_linear_103_16)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8954 23.0442L3.62642 33.9917C2.55019 34.6109 1.58991 34.5678 0.97065 34.0049L0.867981 34.1076L0.97065 34.1969C1.58991 34.7566 2.55019 34.8029 3.62642 34.1837L23.0278 23.1635L22.8954 23.0442Z",
    fill: "#0e0333"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5048 19.2825L22.8788 23.0442L22.9981 23.1635L29.4882 19.4746C30.4188 18.9448 30.8758 18.2493 30.8758 17.5573C30.8194 18.1931 30.346 18.7958 29.5048 19.2825Z",
    fill: "#0e0333"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.61317 1.12281L29.5048 15.8319C30.346 16.3055 30.8195 16.9247 30.8924 17.5571C30.8924 16.8652 30.4354 16.1697 29.5048 15.6399L3.61317 0.930743C1.75554 -0.132206 0.24884 0.755249 0.24884 2.87784V3.0699C0.24884 0.943998 1.75554 0.0731053 3.61317 1.12281Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_103_16",
    x1: 15.9461,
    y1: 2.56115,
    x2: -10.4055,
    y2: 9.58257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_103_16",
    x1: 31.9276,
    y1: 17.5574,
    x2: -0.202673,
    y2: 17.5574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_103_16",
    x1: 19.9662,
    y1: 20.6078,
    x2: -1.18868,
    y2: 56.2133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_103_16",
    x1: -3.31351,
    y1: -8.76255,
    x2: 6.1245,
    y2: 7.13944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_103_16",
    x1: 15.9461,
    y1: 2.56115,
    x2: -10.4055,
    y2: 9.58257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_103_16",
    x1: 31.9276,
    y1: 17.5574,
    x2: -0.202673,
    y2: 17.5574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_103_16",
    x1: 19.9662,
    y1: 20.6078,
    x2: -1.18868,
    y2: 56.2133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_103_16",
    x1: -3.31351,
    y1: -8.76255,
    x2: 6.1245,
    y2: 7.13944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/play-store.698f1310d98497122ec828f077d231b9.svg";
export { ForwardRef as ReactComponent };